import React from "react";
import "./underChartFull.css";
import { Line } from "react-chartjs-2";
import Dropdown from "../Components/dropdown";

const UnderChartFull = ({ amount, netPercentage, status }) => {
  amount = 37.5;
  netPercentage = "+2.5";
  status = "On Track";

  let arr = [120, 117, 150, 178, 140, 111, 90, 105, 120, 130, 140, 150];
  let arr2 = arr.map((item) => item - 35);

  let options = {
    responsive: true,
    plugins: {
      //   tooltip: {
      //     enabled: true, // <-- this option disables tooltips
      //   },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 11,
          },
          display: true,
        },
        grid: {
          drawOnChartArea: false, // Extended vertical lines below x-axis only
        },
      },
      y: {
        display: false,
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        // beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
        },
        grid: {
          display: true, // Show horizontal grid lines
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state = {
    data: {
      // Add labels till 16
      labels: [
        "SEP",
        "OCT",
        "NOV",
        "DEC",
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
      ],
      datasets: [
        {
          label: "Subscriptions",
          backgroundColor: (context) => {
            if (!context.chart.chartArea) return;
            const {
              ctx,
              chartArea: { top, bottom },
            } = context.chart;
            const gradientBackground = ctx.createLinearGradient(
              0,
              top,
              50,
              bottom
            );
            gradientBackground.addColorStop(0, "rgba(226, 36, 47, 0.2)");
            gradientBackground.addColorStop(0.5, "rgba(226, 36, 47, 0.1)");
            gradientBackground.addColorStop(0.9, "rgba(226, 36, 47, 0)");

            return gradientBackground;
          },
          borderColor: "#E2242F",
          data: arr,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
        },
        {
          label: "Unsubscriptions",
          backgroundColor: (context) => {
            if (!context.chart.chartArea) return;
            const {
              ctx,
              chartArea: { top, bottom },
            } = context.chart;
            const gradientBackground = ctx.createLinearGradient(
              0,
              top,
              20,
              bottom
            );
            gradientBackground.addColorStop(0, "rgba(96, 184, 238, 0.2)");
            gradientBackground.addColorStop(0.5, "rgba(96, 184, 238, 0.1)");
            gradientBackground.addColorStop(0.9, "rgba(96, 184, 238, 0)");

            return gradientBackground;
          },
          borderColor: "#60B8EE",
          data: arr2,
          fill: true,
          tension: 0.4,
          pointRadius: 3,
        },
      ],
    },
  };

  return (
    <div className="pvxUnderChartFull">
      <div className="top">
        <Dropdown />
        <img src="./images/PvxDashboard/Icons/BarChart.svg" alt="BarChart" />
      </div>
      <div className="bottom">
        <div className="left">
          <div className="head">
            <div className="amount">${amount}K</div>
            <div className="sub">
              <span className="text">Revenue</span>
              <span className="percentage">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="19"
                  viewBox="0 0 21 19"
                  fill="none"
                >
                  <g clip-path="url(#clip0_16_35216)">
                    <path
                      d="M5.86963 11.351L10.0622 7.61182L14.2547 11.351H5.86963Z"
                      fill="#05CD99"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_16_35216">
                      <rect
                        width="20.1242"
                        height="17.948"
                        fill="white"
                        transform="translate(0 0.881348)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                {netPercentage}%
              </span>
            </div>
          </div>
          <div className="status">
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.304199"
                y="0.757324"
                width="16"
                height="16"
                rx="8"
                fill="#05CD99"
              />
              <g clip-path="url(#clip0_16_35221)">
                <path
                  d="M7.12501 10.506L5.52085 8.90187C5.3421 8.72312 5.05793 8.72312 4.87918 8.90187C4.70043 9.08062 4.70043 9.36478 4.87918 9.54353L6.7996 11.464C6.97835 11.6427 7.2671 11.6427 7.44585 11.464L12.3042 6.6102C12.4829 6.43145 12.4829 6.14729 12.3042 5.96854C12.1254 5.78979 11.8413 5.78979 11.6625 5.96854L7.12501 10.506Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_16_35221">
                  <rect
                    width="11"
                    height="11"
                    fill="white"
                    transform="translate(3 3.08105)"
                  />
                </clipPath>
              </defs>
            </svg>{" "}
            {status}
          </div>
        </div>

        <div className="right">
          <Line
            height="230px"
            width="475px"
            options={options}
            data={state.data}
          />
        </div>
      </div>
    </div>
  );
};

export default UnderChartFull;
